/**
 * "AI 가 돌리는 조회 중" 표시 (2026-09-12, D44)
 *
 * 이 파일은 아무것도 import 하지 않는다. 그래야 Global.ts 가 이것을 써도
 * Global → aiSignal → api → Global 순환이 생기지 않는다.
 * 순환은 tsc 는 통과하지만 기동 시 초기화 순서에 따라 undefined 가 튈 수 있다.
 */
let running = 0;

export const aiSignalFlag = {
  begin() {
    running += 1;
  },
  end() {
    running = Math.max(0, running - 1);
  },
  /** AI 가 돌리는 조회가 진행 중인가 */
  isRunning() {
    return running > 0;
  },
};
